import React from 'react';
import styled from 'styled-components';

import { Container, Button } from 'ui/components/styled';
import { Modal } from 'ui/components/styled/NewModal';

export const ConfirmationModal = ({
  children,
  content,
  contentProps,
  onClose,
  onConfirm,
  cancelButtonProps,
  confirmButtonProps,
  cancelButtonText,
  confirmButtonText,
  show,
  ...rest
}) => {
  const [preventConfirm, setPreventConfirm] = React.useState(false);
  const isMounted = React.useRef(false);
  const ModalContent = content || DefaultModalContent;

  const handleConfirm = async (...params) => {
    setPreventConfirm(true);
    if (onConfirm) {
      await onConfirm(...params);
    }
    if (isMounted.current) {
      setPreventConfirm(false);
    }
  };

  React.useEffect(() => {
    isMounted.current = true;

    return () => (isMounted.current = false);
  }, []);

  return (
    <Modal onRequestClose={onClose} isOpen={show} testId={rest['data-testid']} {...rest}>
      <ModalContent
        onClose={onClose}
        onConfirm={handleConfirm}
        preventConfirm={preventConfirm}
        cancelButtonProps={cancelButtonProps}
        confirmButtonProps={confirmButtonProps}
        cancelButtonText={cancelButtonText}
        confirmButtonText={confirmButtonText}
        {...contentProps}
      >
        {children}
      </ModalContent>
    </Modal>
  );
};

const DefaultModalContent = ({
  children,
  onClose,
  onConfirm,
  preventConfirm,
  cancelButtonProps,
  confirmButtonProps,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Yes',
}) => (
  <>
    <Content mb="l">{children}</Content>
    <Container flexDirection="row" justifyContent="space-between">
      <Button
        data-testid="cancel"
        variant="contrast-primary"
        width="45%"
        boxShadow="none"
        onClick={onClose}
        {...cancelButtonProps}
      >
        {cancelButtonText}
      </Button>
      <Button
        data-testid="confirm"
        width="45%"
        onClick={onConfirm}
        disabled={preventConfirm}
        name="yes"
        {...confirmButtonProps}
      >
        {confirmButtonText}
      </Button>
    </Container>
  </>
);

const Content = styled(Container)`
  font-weight: 500;
  color: #333;
`;
